import { permissionManager } from '../PermissionManager/PermissionManager';

export const COMMENT_ADD_NOTE = 'create-text';
export const COMMENT_ADD_HIGHLIGHT = 'create-highlight';
export const COMMENT_ADD_STRIKEOUT = 'create-strikeout';
export const COMMENT_ADD_UNDERLINE = 'create-underline';
export const COMMENT_ADD_SQUIGGLY = 'create-squiggly';
export const COMMENT_ADD_REPLACE = 'create-replace';
export const COMMENT_ADD_CARET = 'create-caret';
export const COMMENT_ADD_TYPEWRITER = 'freetext-typewriter';
export const COMMENT_ADD_FREETEXT_CALLOUT = 'freetext-callout';
export const COMMENT_ADD_FREETEXT_TEXTBOX = 'freetext-textbox';
export const COMMENT_ADD_FILEATTACHMENT = 'create-fileattachment';

export const COMMENT_ADD_SQUARE = 'create-square';
export const COMMENT_ADD_CIRCLE = 'create-circle';
export const COMMENT_ADD_LINE = 'create-line';
export const COMMENT_ADD_ARROW = 'create-arrow';
export const COMMENT_ADD_POLYGON = 'create-polygon';
export const COMMENT_ADD_POLYLINE = 'create-polyline';
export const COMMENT_ADD_CLOUD = 'create-cloud';

export const COMMENT_ADD_AREA_HIGHLIGHT = 'create-area-highlight';
export const COMMENT_ADD_PENCIL_TOOL = 'pencil-tool';
export const COMMENT_ADD_ERASER_TOOL = 'eraser-tool';

export const COMMENT_ADD_STAMP = 'stamp-drop-down-ui';
export const COMMENT_ADD_CUSTOM_STAMP = 'add-custom-stamp';
export const COMMENT_SET_FAVORITE_STAMP = 'set-favorite-stamps';
export const COMMENT_MANAGE_CUSTOM_STAMP = 'manage-custom-stamp';

export const COMMENT_ADD_DISTANCE = 'create-distance-btn';
export const COMMENT_ADD_PERIMETER = 'create-perimeter-btn';
export const COMMENT_ADD_AREA = 'create-area-btn';
export const COMMENT_ADD_CIRCLE_AREA = 'create-circle-area-btn';
export const COMMENT_SUMMARIZE_COMMENTS_BUTTON = 'summarize-comments-button';
export const COMMENT_EXPORT_WORD_BUTTON = 'comment-export-word-button';
export const COMMENT_IMPORT_BUTTON = "fv--commentlist-import-comment-ribbon-button";
export const COMMENT_EXPORT_XFDF_BUTTON = "fv--export-xfdf-button";
export const COMMENT_EXPORT_FDF_BUTTON = "fv--export-fdf-button";
export const COMMENT_EXPORT_JSON_BUTTON = "fv--export-json-button";
export const COMMENTS_LIST = [
  COMMENT_ADD_NOTE,
  COMMENT_ADD_HIGHLIGHT,
  COMMENT_ADD_STRIKEOUT,
  COMMENT_ADD_UNDERLINE,
  COMMENT_ADD_SQUIGGLY,
  COMMENT_ADD_REPLACE,
  COMMENT_ADD_CARET,
  COMMENT_ADD_TYPEWRITER,
  COMMENT_ADD_FREETEXT_CALLOUT,
  COMMENT_ADD_FREETEXT_TEXTBOX,
  COMMENT_ADD_FILEATTACHMENT,

  COMMENT_ADD_SQUARE,
  COMMENT_ADD_CIRCLE,
  COMMENT_ADD_LINE,
  COMMENT_ADD_ARROW,
  COMMENT_ADD_POLYGON,
  COMMENT_ADD_POLYLINE,
  COMMENT_ADD_CLOUD,

  COMMENT_ADD_AREA_HIGHLIGHT,
  COMMENT_ADD_PENCIL_TOOL,
  COMMENT_ADD_ERASER_TOOL,

  COMMENT_ADD_STAMP,

  COMMENT_ADD_DISTANCE,
  COMMENT_ADD_PERIMETER,
  COMMENT_ADD_AREA,
  COMMENT_ADD_CIRCLE_AREA,

  // COMMENT_ADD_FILEATTACHMENT,
  // COMMENT_ADD_IMAGE,
  // COMMENT_ADD_LINK,
  // COMMENT_ADD_MULTI_MEDIA,
  COMMENT_IMPORT_BUTTON,
  COMMENT_ADD_CUSTOM_STAMP,
  COMMENT_SET_FAVORITE_STAMP,
  COMMENT_MANAGE_CUSTOM_STAMP,
  COMMENT_SUMMARIZE_COMMENTS_BUTTON,
];
// premium features
export const COMMENT_PREMIUM_BTNS = [
  COMMENT_ADD_STAMP,
  COMMENT_ADD_CUSTOM_STAMP,
  COMMENT_SET_FAVORITE_STAMP,
  COMMENT_MANAGE_CUSTOM_STAMP,
  COMMENT_SUMMARIZE_COMMENTS_BUTTON,
  COMMENT_IMPORT_BUTTON,
  COMMENT_EXPORT_XFDF_BUTTON,
  COMMENT_EXPORT_FDF_BUTTON,
  COMMENT_EXPORT_JSON_BUTTON,
];
permissionManager.registerPremiumFeatures(COMMENT_PREMIUM_BTNS);

export const SEARCH_HIGHLIGHT = 'Search & Highlight';
export const BASE_SEARCH = 'Start search';
